/*
  Announcement bar: delivery promise that follows the Santiago clock.
  Markup: sections/announcement-bar.liquid, a block with "dynamic_delivery" on gets data-iw-delivery-bar on its
  <span> and carries both texts. Cutoff hour and holidays come from the section (data-iw-delivery-* on .utility-bar).
  Before the cutoff on a business day it shows the "before" text; otherwise the "after" text with {next_day}
  ("mañana" or "el lunes 26"). The server text stays as the fallback when this script does not run.
*/
(function () {
  'use strict';

  var TIME_ZONE = 'America/Santiago';
  var DAY_NAMES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var DAY_MS = 86400000;

  var formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  });

  function santiagoNow() {
    var values = {};
    formatter.formatToParts(new Date()).forEach(function (part) {
      values[part.type] = part.value;
    });
    return {
      day: Date.UTC(parseInt(values.year, 10), parseInt(values.month, 10) - 1, parseInt(values.day, 10)),
      minutes: parseInt(values.hour, 10) * 60 + parseInt(values.minute, 10)
    };
  }

  function isoOf(dayMs) {
    return new Date(dayMs).toISOString().slice(0, 10);
  }

  function parseHolidays(raw) {
    return (raw || '').split(',').map(function (item) { return item.trim(); }).filter(Boolean);
  }

  function isBusinessDay(dayMs, holidays) {
    var weekday = new Date(dayMs).getUTCDay();
    return weekday >= 1 && weekday <= 5 && holidays.indexOf(isoOf(dayMs)) === -1;
  }

  // First business day on which the order ships: today if the cutoff is still ahead, else the next one.
  function dispatchDay(now, cutoffMinutes, holidays) {
    var day = now.day;
    if (isBusinessDay(day, holidays) && now.minutes < cutoffMinutes) return day;
    do {
      day += DAY_MS;
    } while (!isBusinessDay(day, holidays));
    return day;
  }

  function label(now, dayMs) {
    var diff = Math.round((dayMs - now.day) / DAY_MS);
    if (diff === 0) return 'hoy';
    if (diff === 1) return 'mañana';
    var date = new Date(dayMs);
    return 'el ' + DAY_NAMES[date.getUTCDay()] + ' ' + date.getUTCDate();
  }

  function update(span) {
    var bar = span.closest('[data-iw-delivery-cutoff]');
    if (!bar) return;
    var cutoffMinutes = (parseInt(bar.getAttribute('data-iw-delivery-cutoff'), 10) || 12) * 60;
    var holidays = parseHolidays(bar.getAttribute('data-iw-delivery-holidays'));
    var now = santiagoNow();
    var when = label(now, dispatchDay(now, cutoffMinutes, holidays));
    var text = when === 'hoy'
      ? span.getAttribute('data-text-before')
      : (span.getAttribute('data-text-after') || '').replace('{next_day}', when);
    if (text && span.textContent !== text) span.textContent = text;
  }

  function init() {
    var spans = document.querySelectorAll('[data-iw-delivery-bar]');
    if (!spans.length) return;
    function run() {
      Array.prototype.forEach.call(spans, update);
    }
    run();
    window.setInterval(run, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
